(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/oddsmind-chat/assets/javascripts/oddsmind-chat-react-component.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/oddsmind-chat/assets/javascripts/oddsmind-chat-react-component.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const oddsmindNavigate = svs.oddset_kambi.components.oddsmind_chat.oddsmindNavigate;
const oddsmindConfig = svs.oddset_kambi.data.oddsmindConfig;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useCallback = _React.useCallback;
const environment = svs.oddset_kambi.data.kambiEnv;
const getOddsmindOffset = svs.oddset_kambi.components.common.utils.getOddsmindOffset;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
svs.oddsmind = svs.oddsmind || {};
const OddsmindChatReactComponent = _ref => {
  let isSmallScreen = _ref.isSmallScreen;
  svs.oddsmind.isSmallScreen = isSmallScreen; 
  const oddsmindRef = useRef(null);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    headerVisible = _useState2[0],
    setHeaderVisible = _useState2[1];
  const intersectionCallback = useCallback(entries => {
    entries.forEach(entry => {
      setHeaderVisible(entry.isIntersecting);
    });
  }, []);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    const observer = new IntersectionObserver(intersectionCallback, options);
    const page = document.querySelector('.js-top-content-wrapper');
    if (page) {
      observer.observe(page);
    }
    return () => {
      if (page) {
        observer.unobserve(page);
      }
    };
  }, [intersectionCallback]);
  useEffect(() => {
    const oddsmindElement = oddsmindRef.current;
    if (!oddsmindElement) {
      return undefined;
    }
    const handleBetIntercept = e => {
      e.preventDefault();
      svs.components.analytics.trackEvent({
        category: 'oddset',
        action: 'oddsmind',
        opt_label: 'send to betslip'
      });
      oddsmindNavigate(e.detail);
    };
    const handleWidgetOpened = () => {
      svs.components.analytics.trackEvent({
        category: 'oddset',
        action: 'oddsmind',
        opt_label: 'initiate oddsmind'
      });
    };
    oddsmindElement.addEventListener('bet_intercept', handleBetIntercept);
    oddsmindElement.addEventListener('oddsmind:widget_opened', handleWidgetOpened);
    return () => {
      oddsmindElement.removeEventListener('bet_intercept', handleBetIntercept);
      oddsmindElement.removeEventListener('oddsmind:widget_opened', handleWidgetOpened);
    };
  }, []);
  return React.createElement("oddsmind-chat", {
    "api-url": environment === 'prod' ? 'https://prod.oddsmind.ai' : 'https://chat.oddsmind.ai',
    backdrop: "none" 
    ,
    badge: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.badgeText) || ''),
    "bookmaker-id": "32",
    "bottom-offset": getOddsmindOffset({
      isLoggedIn,
      isSmallScreen
    }).bottom,
    "client-id": "svenskaspel"
    ,
    country: "SE"
    ,
    "footer-label": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.linkText) || 'OddsMind'),
    "footer-note": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.footerNote) || ''),
    "footer-prefix": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.footerPrefix) || ''),
    "footer-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.link) || 'https://oddsmind.ai') 
    ,
    "header-image-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.headerImage) || '') 
    ,
    "icon-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.iconUrl) || '') 
    ,
    "intercept-bets": "true",
    language: "sv",
    "launcher-image-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.openOddsmindImage) || '') 
    ,
    "launcher-image-url-mobile": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.openOddsmindImageMobile) || '') 
    ,
    mode: "floating" 
    ,
    "parent-origin": "".concat(window.location.origin)
    ,
    position: "bottom-right",
    "quick-chips": "true" 
    ,
    ref: oddsmindRef,
    subtitle: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.subheader) || 'AI Betting Assistant'),
    title: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.header) || 'OddsMind'),
    "top-offset": getOddsmindOffset({
      isLoggedIn,
      isSmallScreen,
      headerVisible
    }).top
    ,
    welcome: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.welcomeMessage) || 'Hej! Jag är din AI-assistent för spel på fotboll — just nu med fokus på VM 2026. Fråga mig om en match, ett lag eller en spelare så ger jag dig statistik och ett spelförslag. Jag kan inte allt ännu, men lär mig hela tiden!')
    ,
    "widget-key": "widget_sOpEbLybS6h5QD201n6JpMZ12shh4_bvBGRfMO7e8E0" 
    ,
    "z-index": "301"
  });
};
setGlobal('svs.oddset_kambi.components.oddsmind_chat.OddsmindChatReactComponent', OddsmindChatReactComponent);

 })(window);